import { Box, Flex } from '@radix-ui/themes';
import type { ComponentProps } from 'react';
import { Logo } from '../Logo/Logo';
import Styles from './header.module.scss';
import { cn } from '~/utils/classNames';
import { useStore } from '@nanostores/react';
import { interfaceStore } from '~/stores/interface';

type HeaderProps = ComponentProps<typeof Flex> & {
  disableLink?: boolean;
  href?: string;
};

export function Header({ href = '/', disableLink = false, className, children }: HeaderProps) {
  const appearanceMode = useStore(interfaceStore.appearanceMode);
  return (
    <Flex
      asChild
      width="100%"
      justify="between"
      align="center"
      gap="2"
      height="5.5rem"
      px="3"
      className={cn(Styles.Header, className)}
    >
      <nav>
        <Flex align="center" justify="between" width="100%">
          <Logo component="img" appearance={appearanceMode} href={href} disableLink={disableLink} />
          <Box>{children}</Box>
        </Flex>
      </nav>
    </Flex>
  );
}
